import Page from '../../classes/Page'
import Maps from '../../modules/Maps'

export default class SingleStore extends Page {
    constructor() {
        super({
            id: 'single_store',
            element: '[data-app-page]',
            elements: {
                map: '#map',
            },
        })

        this.map = null
    }

    async create() {
        super.create()

        if (this.elements.map.dataset.location) {
            let location = JSON.parse(this.elements.map.dataset.location)

            if (location.lat && location.lng) {
                this.coordinates = {
                    lat: parseFloat(location.lat),
                    lng: parseFloat(location.lng),
                }

                this.id = this.elements.map.dataset.id
                this.title = this.elements.map.dataset.title
                this.website = location.website
                this.city = location.mark.city
                this.address = location.mark.address
                this.spaces = location.spaces
                this.filter = location.filter
                
                this.map = new Maps({
                    element: this.elements.map,
                    zoom: {
                        value: 12,
                        controls: {
                            enable: false,
                        }
                    },
                    coordinates: {
                        lat: this.coordinates.lat,
                        lng: this.coordinates.lng
                    },
                    ui: false,
                    wheel: false,
                    fullscreen: false,
                    streetView: false,
                    mapTypeControl: false,
                    draggable: true,
                    stores: [this.elements.map],
                })

                this.map.create({
                    search: null,
                    markers: true,
                }, true)
            }
        }
    }

    addEventListeners() {}

    destroy() {
        super.destroy()
    }
}